import { useEffect, useState, useCallback } from 'react';
import client from '../api/client';
import { getCode, setCode, clearCode, lockMessage } from '../api/lionjob';

// LỊCH MÙA VỤ — thứ matrixty hoàn toàn không có.
// Biết Halloween đang hot thì dễ; biết CÒN KỊP LIST KHÔNG mới là việc khó.
// Ytrends trả ngày nên-bắt-đầu cho từng sự kiện, backend so với hôm nay ra độ gấp.
const hdr = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 20000 });
const api = {
  calendar: () => client.get('/lionjob/ytrends/calendar', hdr()).then((r) => r.data.data),
  sync: () => client.post('/lionjob/ytrends/sync', {}, { ...hdr(), timeout: 300000 }).then((r) => r.data),
};

// Xếp theo việc phải làm, không theo điểm.
const STAGES = [
  { key: 'now', label: 'List NGAY', cls: 'now', hint: 'Đã tới hoặc qua mốc nên bắt đầu, chưa tới đỉnh' },
  { key: 'peak', label: 'Đang đỉnh', cls: 'peak', hint: 'Vào lúc này chỉ kịp phần đuôi' },
  { key: 'soon', label: 'Sắp tới hạn', cls: 'soon', hint: 'Còn dưới 2 tuần là tới mốc' },
  { key: 'early', label: 'Còn sớm', cls: 'early', hint: 'Chưa cần làm, theo dõi tiếp' },
  { key: 'late', label: 'Đã qua đỉnh', cls: 'late', hint: 'Mùa này lỡ rồi, để sang năm' },
  { key: 'unknown', label: 'Thiếu ngày', cls: 'unknown', hint: 'Ytrends không trả ngày' },
];
const N = (v, d = 0) => (v == null ? '—' : new Intl.NumberFormat('vi-VN', { maximumFractionDigits: d }).format(v));
const money = (v) => (v == null ? '—' : '$' + new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(v));
const dmy = (s) => (s ? s.slice(8, 10) + '/' + s.slice(5, 7) : '—');

export default function CalendarPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('all');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setData(await api.calendar()); setUnlocked(true); }
    catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); return; }
      if (e.response?.status === 404) { setUnlocked(true); setData(null); setMsg(m); return; }
      setLockErr(lockMessage(e)); setMsg('Lỗi: ' + m);
    }
  }, []);
  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }
  async function doSync() {
    setBusy(true); setMsg('Đang kéo dữ liệu mới từ Ytrends…');
    try { const r = await api.sync(); setMsg('✓ ' + r.message); await load(); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(false); }
  }

  if (!unlocked) {
    return (
      <div className="cl-root"><style>{CSS}</style>
        <div className="cl-lock"><div className="cl-lockCard">
          <div className="cl-lockIco">🦁</div><h2>Lịch mùa vụ</h2>
          <p className="cl-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="cl-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="cl-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="cl-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  const counts = data?.counts || {};
  const events = (data?.events || []).filter((e) => filter === 'all' || e.stage === filter);
  const urgent = (counts.now || 0) + (counts.peak || 0);
  // Dữ liệu cũ thì lịch vô nghĩa — cảnh báo rõ thay vì để người dùng tin nhầm.
  const stale = data?.day && (new Date() - new Date(data.day + 'T00:00:00')) / 86400000 > 3;

  return (
    <div className="cl-root"><style>{CSS}</style>
      <div className="cl-head">
        <div>
          <h2>Lịch mùa vụ</h2>
          <div className="cl-sub">{msg || 'Sự kiện nào phải bắt đầu list hôm nay — tính từ ngày Ytrends khuyến nghị so với hôm nay.'}</div>
        </div>
        <div className="cl-sp" />
        <button className="cl-btn primary" onClick={doSync} disabled={busy}>
          {busy ? '⏳ Đang kéo…' : '⤓ Kéo dữ liệu mới'}</button>
      </div>

      {!data ? (
        <div className="cl-empty">
          <div style={{ fontSize: 34, marginBottom: 8 }}>📅</div>
          <b>Chưa có dữ liệu Ytrends</b>
          <p>Bấm <b>⤓ Kéo dữ liệu mới</b>. Sau lần đầu, backend sẽ tự kéo mỗi ngày.</p>
        </div>
      ) : (
        <>
          {urgent > 0 && (
            <div className="cl-alert">
              <b>{urgent} sự kiện cần làm ngay.</b> Mốc nên bắt đầu đã tới hoặc đã qua — mỗi ngày chậm là mất một ngày chạy đà trước đỉnh.
            </div>
          )}
          {stale && (
            <div className="cl-alert warn">
              <b>Dữ liệu từ {dmy(data.day)}</b> — đã cũ. Lịch tính theo hôm nay nên có thể lệch. Bấm <b>Kéo dữ liệu mới</b>.
            </div>
          )}

          <div className="cl-filters">
            <button className={'cl-pill' + (filter === 'all' ? ' on' : '')} onClick={() => setFilter('all')}>
              Tất cả <span className="c">{data.events.length}</span></button>
            {STAGES.filter((s) => counts[s.key]).map((s) => (
              <button key={s.key} className={`cl-pill ${s.cls}` + (filter === s.key ? ' on' : '')}
                onClick={() => setFilter(s.key)} title={s.hint}>
                {s.label} <span className="c">{counts[s.key]}</span></button>
            ))}
            <span className="cl-asof">dữ liệu tới {data.asOf || data.day}{data.dataAgeDays != null ? ` · Ytrends trễ ~${data.dataAgeDays}n` : ''}</span>
          </div>

          <div className="cl-grid">
            {events.length === 0 && <div className="cl-empty">Không có sự kiện nào ở mức này.</div>}
            {events.map((e, i) => (
              <div key={e.event + i} className={`cl-card ${e.stage}`}>
                <div className="cl-top">
                  <span className={`cl-stage ${e.stage}`}>{e.stageLabel}</span>
                  {e.grade && <span className="cl-grade">{e.grade}</span>}
                  <span className="cl-opp">{N(e.opportunity, 1)}</span>
                </div>
                <div className="cl-name">{e.event}</div>
                <div className="cl-note">{e.note}</div>

                {/* Thanh thời gian: từ mốc bắt đầu tới đỉnh, chấm đỏ là hôm nay */}
                <Timeline ev={e} />

                <div className="cl-dates">
                  <span><i>Bắt đầu</i> <b>{dmy(e.listStart)}</b></span>
                  <span><i>Đỉnh</i> <b>{dmy(e.peakDate)}</b></span>
                  {e.prepWindowDays != null && <span><i>Chuẩn bị</i> <b>{e.prepWindowDays}n</b></span>}
                </div>

                <div className="cl-mets">
                  <M k="Cạnh tranh" v={e.competition || '—'} good={e.competition === 'low'} />
                  <M k="Người bán" v={N(e.sellers)} />
                  <M k="Bán 24h" v={N(e.sold24h)} />
                  <M k="Doanh thu" v={money(e.revenue)} />
                </div>
                {e.action && <div className="cl-action">{e.action}</div>}
              </div>
            ))}
          </div>

          {data.insights?.length > 0 && (
            <div className="cl-insights">
              <h3>Ytrends nhận định</h3>
              {data.insights.map((s, i) => <div key={i} className="cl-ins">▸ {s}</div>)}
            </div>
          )}
        </>
      )}
    </div>
  );
}

// Thanh thời gian đơn giản: |--- bắt đầu ...... đỉnh ---| và vị trí hôm nay.
function Timeline({ ev }) {
  const { daysToStart, daysToPeak } = ev;
  if (daysToStart == null || daysToPeak == null) return null;
  const span = daysToPeak - daysToStart;              // tổng cửa sổ chạy đà
  if (span <= 0) return null;
  const pct = Math.max(0, Math.min(100, ((-daysToStart) / span) * 100));  // hôm nay ở đâu
  return (
    <div className="cl-tl" title={`Cửa sổ chạy đà ${span} ngày`}>
      <div className="cl-tlbar"><div className="cl-tlfill" style={{ width: pct + '%' }} /></div>
      <div className="cl-tldot" style={{ left: pct + '%' }} />
    </div>
  );
}
function M({ k, v, good }) {
  return <div className={'cl-m' + (good ? ' good' : '')}><div className="cl-mk">{k}</div><div className="cl-mv">{v}</div></div>;
}

const CSS = `
.cl-root{color:var(--text);padding-bottom:30px}
.cl-head{display:flex;gap:10px;align-items:flex-start;margin-bottom:14px;flex-wrap:wrap}
.cl-head h2{margin:0;font-size:20px}
.cl-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:72ch}
.cl-sp{flex:1}
.cl-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 13px;border-radius:9px;cursor:pointer;font-size:13px}
.cl-btn:hover:not(:disabled){border-color:var(--accent)}
.cl-btn:disabled{opacity:.45;cursor:not-allowed}
.cl-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}

.cl-alert{border:1px solid var(--danger);border-left:3px solid var(--danger);background:var(--panel);
  border-radius:var(--radius);padding:11px 15px;font-size:13px;color:var(--muted);margin-bottom:12px}
.cl-alert b{color:var(--text)}
.cl-alert.warn{border-color:var(--warn);border-left-color:var(--warn)}

.cl-filters{display:flex;gap:7px;align-items:center;flex-wrap:wrap;margin-bottom:14px}
.cl-pill{border:1px solid var(--border);background:var(--panel);color:var(--muted);font:inherit;font-size:12px;
  padding:5px 11px;border-radius:20px;cursor:pointer;display:inline-flex;gap:6px;align-items:center}
.cl-pill:hover{border-color:var(--accent);color:var(--text)}
.cl-pill .c{font-family:var(--font-mono);font-size:11px}
.cl-pill.on{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}
.cl-pill.now{border-color:var(--danger);color:var(--danger)}
.cl-pill.now.on{background:var(--danger);border-color:var(--danger);color:#fff}
.cl-pill.peak{border-color:var(--warn);color:var(--warn)}
.cl-pill.peak.on{background:var(--warn);border-color:var(--warn);color:#fff}
.cl-asof{margin-left:auto;font-size:11px;color:var(--muted);font-family:var(--font-mono)}

.cl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:12px}
.cl-card{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:13px 15px;
  display:flex;flex-direction:column;gap:7px}
.cl-card.now{border-left:3px solid var(--danger)}
.cl-card.peak{border-left:3px solid var(--warn)}
.cl-card.soon{border-left:3px solid var(--info)}
.cl-card.late{opacity:.6}
.cl-top{display:flex;align-items:center;gap:7px}
.cl-stage{font-size:10.5px;font-weight:700;border-radius:5px;padding:2px 8px;border:1px solid var(--border);color:var(--muted)}
.cl-stage.now{color:var(--danger);border-color:var(--danger)}
.cl-stage.peak{color:var(--warn);border-color:var(--warn)}
.cl-stage.soon{color:var(--info);border-color:var(--info)}
.cl-stage.early{color:var(--ok);border-color:var(--ok)}
.cl-grade{font-size:10.5px;font-family:var(--font-mono);color:var(--muted);border:1px solid var(--border);border-radius:5px;padding:1px 6px}
.cl-opp{margin-left:auto;font-family:var(--font-mono);font-size:15px;font-weight:600;color:var(--accent)}
.cl-name{font-size:14.5px;font-weight:600;text-transform:capitalize}
.cl-note{font-size:12px;color:var(--muted);line-height:1.5}

.cl-tl{position:relative;height:14px;display:flex;align-items:center}
.cl-tlbar{height:4px;width:100%;background:var(--input);border-radius:20px;overflow:hidden}
.cl-tlfill{height:100%;background:var(--accent);border-radius:20px}
.cl-tldot{position:absolute;width:9px;height:9px;border-radius:50%;background:var(--danger);
  border:2px solid var(--panel);transform:translateX(-50%)}

.cl-dates{display:flex;gap:12px;font-size:11.5px;color:var(--muted);flex-wrap:wrap}
.cl-dates i{font-style:normal;text-transform:uppercase;font-size:9.5px;letter-spacing:.06em}
.cl-dates b{font-family:var(--font-mono);color:var(--text)}
.cl-mets{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}
.cl-m{background:var(--input);border-radius:7px;padding:5px 7px;min-width:0}
.cl-mk{font-size:9px;letter-spacing:.05em;text-transform:uppercase;color:var(--muted);font-weight:600}
.cl-mv{font-family:var(--font-mono);font-size:12px;font-weight:600;margin-top:1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.cl-m.good .cl-mv{color:var(--ok)}
.cl-action{font-size:11.5px;color:var(--muted);border-top:1px solid var(--line);padding-top:7px;line-height:1.5}

.cl-insights{margin-top:16px;background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:13px 16px}
.cl-insights h3{margin:0 0 8px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}
.cl-ins{font-size:12.5px;color:var(--muted);line-height:1.6}
.cl-empty{grid-column:1/-1;border:1px dashed var(--border);border-radius:var(--radius);padding:44px 24px;text-align:center;color:var(--muted)}
.cl-empty b{color:var(--text);display:block;margin-bottom:6px}
.cl-empty p{font-size:13px;margin:0 auto;max-width:48ch}

.cl-lock{display:flex;justify-content:center;padding:60px 20px}
.cl-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.cl-lockIco{font-size:38px;line-height:1}.cl-lockCard h2{margin:8px 0 4px}
.cl-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.cl-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.cl-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
